import { render, staticRenderFns } from "./PageHeadline.vue?vue&type=template&id=5725c3c0&scoped=true&"
import script from "./PageHeadline.vue?vue&type=script&lang=js&"
export * from "./PageHeadline.vue?vue&type=script&lang=js&"
import style0 from "./PageHeadline.vue?vue&type=style&index=0&id=5725c3c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5725c3c0",
  null
  
)

export default component.exports